import { Nav } from '../components/Nav'
import { CarbonWorld } from '../sections/CarbonWorld'
import Problem from '../sections/Problem'
import Solution from '../sections/Solution'
import Gallery from '../sections/Gallery'
import HowItWorks from '../sections/HowItWorks'
import Tiers from '../sections/Tiers'
import News from '../sections/News'
import Traction from '../sections/Traction'
import About from '../sections/About'
import CallToAction from '../sections/CallToAction'
import Footer from '../sections/Footer'

export default function Landing() {
  return (
    <>
      <Nav />
      <main>
        <CarbonWorld />
        <Problem />
        <Solution />
        <Gallery />
        <HowItWorks />
        <Tiers />
        <News />
        <Traction />
        <About />
        <CallToAction />
      </main>
      <Footer />
    </>
  )
}
